import type { TabContext } from '@/entities/tab/model/tab.types';

/**
 * 경로별 위계 레벨 (등고선).
 * 숫자가 클수록 진입점에 가깝고, 작을수록 하위 플로우.
 *
 * - Level 2: 진입점 (내 상담, 내 일정, 주문 목록 등)
 * - Level 1: 상담 상세, 상담 진행
 * - Level 0: 상담 시작, 집 스케치, 영상 촬영 (progress 하위)
 *
 * 위계가 높아질 때(목적지 레벨 > 현재 레벨): replace (이전 페이지 저장 안 함)
 *   예: 상담시작→상담진행, 집스케치→상담진행 리다이렉트 시
 * 같거나 낮아질 때: append (이전 페이지 저장)
 */
const ROUTE_LEVEL_MAP: { pattern: string[]; level: number }[] = [
  { pattern: ['my', 'counsels', ':visitCounselId', 'progress', 'house-sketch'], level: 0 },
  { pattern: ['my', 'counsels', ':visitCounselId', 'progress', 'house-sketch-video'], level: 0 },
  { pattern: ['my', 'counsels', ':visitCounselId', 'progress', 'room-record'], level: 0 },
  { pattern: ['my', 'counsels', ':visitCounselId', 'progress', 'room-moving-items'], level: 0 },
  { pattern: ['my', 'counsels', ':visitCounselId', 'progress', 'intake'], level: 0 },
  { pattern: ['my', 'counsels', ':visitCounselId', 'progress', 'moving-item-services'], level: 0 },
  { pattern: ['my', 'counsels', ':visitCounselId', 'start'], level: 0 },
  { pattern: ['my', 'counsels', ':visitCounselId', 'progress'], level: 1 },
  { pattern: ['my', 'counsels', ':visitCounselId'], level: 1 },
  { pattern: ['my', 'counsels'], level: 2 },
  { pattern: ['my', 'planner'], level: 2 },
  { pattern: ['my', 'profile'], level: 2 },
  { pattern: ['orders', 'list'], level: 2 },
  { pattern: ['orders', ':misoOrderId'], level: 2 },
  { pattern: ['planners', 'list'], level: 2 },
  { pattern: ['planners', ':plannerId'], level: 2 },
  { pattern: ['home'], level: 2 },
  { pattern: ['activity'], level: 2 },
  { pattern: ['counsel-map'], level: 2 },
  { pattern: ['moving-items'], level: 2 },
  { pattern: ['settings', 'permissions'], level: 2 },
];

function pathMatches(pattern: string[], path: string[]): boolean {
  if (pattern.length !== path.length) return false;
  for (let i = 0; i < pattern.length; i++) {
    if (pattern[i].startsWith(':')) {
      if (!path[i]?.length) return false;
      continue;
    }
    if (pattern[i] !== path[i]) return false;
  }
  return true;
}

export function getRouteLevel(context: TabContext): number {
  const path = context.path ?? [];
  for (const { pattern, level } of ROUTE_LEVEL_MAP) {
    if (pathMatches(pattern, path)) return level;
  }
  return 1;
}
